import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import {
  TextInput,
} from "components/Input/Index.js";
import CustomSelect from "components/Input/CustomSelect.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { avobboxtext } from "variables/MBM/avobbox";
import { serverTypeLorawanGateway } from "variables/MBM/lists/avobbox";
import { postMBMAVOBBox, putMBMAVOBBox, getMBMIotConnectors, getMBMAVOBBoxs } from "services/ConfigServices";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import LocalizationAutocomplete from "components/LocalizationAutocomplete/LocalizationAutocomplete";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
  submitButtonEdit: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "5ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabledEdit: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "5ch",
    width: "60ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

function GatewaysDialog(props) {
  const { closeModal, refetch, currentBox } = props;
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = advancedSearchContext;

  const [servertype, setServertype] = useState(currentBox.otherparameters?.servertype || "");
  const [server, setServer] = useState(currentBox.otherparameters?.server || "");

  const [iotconnectors, setIotconnectors] = useState([]);
  const [avobboxids, setAvobboxids] = useState([]);

  const [iotconnectorselected, setIotconnectorselected] = useState("");

  const [name, setName] = useState(currentBox?.name || "");
  const [iotconnector, setIotconnector] = useState(currentBox?.iotconnector || "");
  const [description, setDescription] = useState(currentBox?.description || "");
  const [organizationid, setOrganizationid] = useState("");
  const [gatewayid, setGatewayid] = useState(currentBox?.gatewayid || "");
  const [location, setLocation] = useState(currentBox?.chirpstackparameters?.location || "");

  //const [servertype, setServertype] = useState(currentBox?.otherparameters?.address || {});

  const [groups, setGroups] = useState(currentBox?.groupid ? "" + currentBox.groupid : "");
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const [address, setAddress] = useState(currentBox?.otherparameters?.address || {});
  const [validatedaddress, setValidatedaddress] = useState(currentBox?.otherparameters?.validatedaddress || {});
  const loaded = useRef(false);
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    if (
      name.length > 0 &&
      description.length > 0 &&
      gatewayid.length > 0 &&
      iotconnectors &&
      location &&
      groups.length > 0
    ) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }, [name, groups, iotconnector, description, gatewayid, location]);


  useEffect(() => {
    let newlocation = {};
    newlocation.altitude = 0;
    newlocation.accuracy = 0;
    newlocation.source = "UNKNOWN";
    newlocation.latitude = validatedaddress?.geometry?.location?.lat || 0;
    newlocation.longitude = validatedaddress?.geometry?.location?.lng || 0;
    setLocation(newlocation);
    console.log(newlocation);
  }, [validatedaddress]);

  useEffect(() => {
    if (chartIdGroup > 0) {
      axios
        .get(
          getMBMIotConnectors(chartIdGroup, "avoblorawanserver"),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          let tmpConnectorsData = res.data.iotconnectors?.map((data) => {
            if (data.connectionproperties && data.connectionproperties.gatewayprofileid && data.connectionproperties.networkserverid && data.connectionproperties.organizationid) {
              return (
                {
                  name: data.name, id: data.id, networkserverid: data.connectionproperties?.networkserverid,
                  gatewayprofileid: data.connectionproperties?.gatewayprofileid, organizationid: data.connectionproperties?.organizationid
                }
              );
            }
          });
          setIotconnectors(tmpConnectorsData || []);
        });

      axios
        .get(
          getMBMAVOBBoxs(chartIdGroup, "avobenergybox"),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          let tmpavobboxidsData = res.data.avobboxs?.map((data) => {
            return (
              {
                name: data.name, id: data.uniqueid
              }
            );

          });
          setAvobboxids(tmpavobboxidsData || []);
        });

    }
  }, [chartIdGroup]);

  const handleSubmit = async (event) => {
    if (currentBox)
      updateAVOBbox(event);
    else
      createAvobbox(event);
  };

  const handleNameChange = (event) => { setName(event.target.value); };
  const handleGatewayidChange = (event) => { setGatewayid(event.target.value); };
  const handleDescriptionChange = (event) => { setDescription(event.target.value); };
  const handleServerChange = (event) => {
    setServer(event.target.value);
  };
  const handleServertypeChange = (event) => {
    if (event.target.value === 'avoblorawanserver')
      setServer("lora.avob.com");
    else if (event.target.value === 'avobenergybox')
      setServer("");
    setServertype(event.target.value);
  };
  const handleIotconnectorChange = (event) => {
    let connector = iotconnectors.find((o) => o.id === event.target.value);
    setIotconnectorselected(connector);
    setIotconnector(event.target.value);
  };
  const handleOrganizationidChange = (event) => { setOrganizationid(event.target.value); };

  const createAvobbox = async (event) => {
    await axios
      .post(
        postMBMAVOBBox(),
        {
          groups,
          iotconnector,
          name,
          description,
          gatewayid,
          location,
          networkserverid: iotconnectorselected.networkserverid,
          gatewayprofileid: iotconnectorselected.gatewayprofileid,
          organizationid: iotconnectorselected.organizationid,
          validatedaddress,
          address,
          type: "4"
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        console.log(res);
        if (res.status == 200) {
          setNotification("success", "Box créée");
        } else setNotification("error", res.data.message);
        closeModal();
        refetch();
      })
      .catch((error) => {
        console.log(error.response);
        setNotification("error", "Une erreur est survenue : " + error.response?.data?.message);
      });
  };

  const updateAVOBbox = async (event) => {

    await axios
      .put(
        putMBMAVOBBox(currentBox.id, "update"),
        {
          groups,
          name,
          description,
          location,
          validatedaddress,
          address,
          server,
          servertype,
          type: "4"
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Box modifiée");
        } else setNotification("error", "Une erreur est survenue");
        closeModal();
        refetch();
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const classes = useStyles();

  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={6} md={7} lg={7}>
            <div>
              <CustomSelect
                inputTitle={avobboxtext.servertype}
                selectValue={servertype}
                handleSelectValueChange={handleServertypeChange}
                data={serverTypeLorawanGateway}
              />
            </div>
            {servertype === 'avobenergybox' && (
              <div>
                <CustomSelect
                  inputTitle={avobboxtext.server}
                  selectValue={server}
                  handleSelectValueChange={handleServerChange}
                  data={avobboxids}
                />
              </div>
            )}
            {servertype === 'avoblorawanserver' && (
              <div>
                <CustomSelect
                  inputTitle={avobboxtext.iotconnector}
                  selectValue={iotconnector}
                  handleSelectValueChange={handleIotconnectorChange}
                  data={iotconnectors}
                  disabled={currentBox}
                />
              </div>)}
            < div >
              <TextInput
                isRequired
                inputTitle={avobboxtext.name}
                textInput={name}
                handleTextInputChange={handleNameChange}
              />
            </div>
            <div>
              <TextInput
                isRequired
                inputTitle={avobboxtext.description}
                textInput={description}
                handleTextInputChange={handleDescriptionChange}
              />
            </div>
            <div>
              <TextInput
                isRequired
                inputTitle={avobboxtext.gatewayid}
                textInput={gatewayid}
                handleTextInputChange={handleGatewayidChange}
                disabled={currentBox}
              />
            </div>
            <div>
              <LocalizationAutocomplete
                isRequired
                specialWidth={"97%"}
                inputTitle={avobboxtext.address}
                value={address}
                setValue={setAddress}
                inputValue={inputValue}
                setInputValue={setInputValue}
                options={options}
                setOptions={setOptions}
                setValidatedAddress={setValidatedaddress}
                validatedAddress={validatedaddress}
                loaded={loaded}
              />
            </div>

          </GridItem>

          <GridItem xs={12} sm={6} md={5} lg={5}>
            <div className={classes.treeVisible}>
              <TreeLabel>Choix du périmètre</TreeLabel>
              <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                <EmbeddedEntitesTree
                  selectedIds={setGroups}
                  userSelectedIds={groups}
                  filterfromnode={chartIdGroup[0]}
                />
              </ImageList>
            </div>
          </GridItem>

        </GridContainer>
        <Button
          disabled={buttonDisabled}
          className={
            currentBox ?
              buttonDisabled
                ? classes.submitButtonDisabledEdit
                : classes.submitButtonEdit
              :
              buttonDisabled
                ? classes.submitButtonDisabled
                : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Enregistrer
        </Button>
      </form>
    </>
  );
}

export default GatewaysDialog;
